import * as React from "react";
import type { SVGProps } from "react";
const SvgStarOfLife = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2.804l2.428-1.402a2 2 0 0 1 2.732.732l1 1.732a2 2 0 0 1-.732 2.732L18 12l2.428 1.402a2 2 0 0 1 .732 2.732l-1 1.732a2 2 0 0 1-2.732.732L15 17.196V20a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2.804l-2.428 1.402a2 2 0 0 1-2.732-.732l-1-1.732a2 2 0 0 1 .732-2.732L6 12l-2.428-1.402a2 2 0 0 1-.732-2.732l1-1.732a2 2 0 0 1 2.732-.732L9 6.804V4Zm4 0h-2v4.519a1.01 1.01 0 0 1-1.515.874L5.572 7.134l-1 1.732 3.913 2.26a1.01 1.01 0 0 1 0 1.749l-3.913 2.259 1 1.732 3.913-2.26a1.01 1.01 0 0 1 1.515.875V20h2v-4.519a1.01 1.01 0 0 1 1.515-.874l3.913 2.259 1-1.732-3.913-2.26a1.01 1.01 0 0 1 0-1.749l3.913-2.259-1-1.732-3.913 2.26A1.01 1.01 0 0 1 13 8.518V4Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgStarOfLife;
